import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import Row from "../common/layout/row";
import Select from "../common/form/select";
import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import Tr from "../common/table/tr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";

import BotaoExcluir from "../common/button/botaoExcluir";
import NumberFormat from "react-number-format";
import avatarGradiosPositivo from "../assets/images/avatar_gradios_positivo.png";
import avatarGradiosNegativo from "../assets/images/avatar_gradios_negativo.png";
import { listarMesesAnosEntreCompetencias } from "../utils/listarMesesAnosEntreCompetencias";

function RenderizarAnaliseMercadoLivre(props) {
    useEffect(() => {
        const modalidadeAtacado = props.dados.id_modalidade_mercado_livre == 1;

        const {
            quantidadeDemandaForaPontaCalculada,
            valorDemandaForaPontaCalculada,
            quantidadeUltrapassagemDemandaForaPontaCalculada,
            valorUltrapassagemDemandaForaPontaCalculada,
        } = (props.dados.lista_quantidade_demanda_fora_ponta || []).reduce(
            (acc, atual) => {
                //se a quantidade atingiu 500, usa o proprio valor
                if (!modalidadeAtacado || atual.quantidade_demanda_fora_ponta >= 500) {
                    acc.quantidadeDemandaForaPontaCalculada += atual.quantidade_demanda_fora_ponta;
                    acc.valorDemandaForaPontaCalculada += atual.valor_demanda_fora_ponta;
                    acc.quantidadeUltrapassagemDemandaForaPontaCalculada += atual.quantidade_ultrapassagem_demanda_fora_ponta;
                    acc.valorUltrapassagemDemandaForaPontaCalculada += atual.valor_ultrapassagem_demanda_fora_ponta;
                } else {
                    //senão for, incrementa até dar 500, e o valor incrementado desconta da ultrapassagem, caso exista.
                    const valorPorKwDemanda = atual.valor_demanda_fora_ponta / atual.quantidade_demanda_fora_ponta;
                    const diferenca = 500 - atual.quantidade_demanda_fora_ponta;
                    acc.quantidadeDemandaForaPontaCalculada += atual.quantidade_demanda_fora_ponta + diferenca;
                    acc.valorDemandaForaPontaCalculada += atual.valor_demanda_fora_ponta + valorPorKwDemanda * diferenca; //usa o valor total incrementado com o valor proporcional aos kW adicionados

                    const valorPorKwUltrapassagem = atual.valor_ultrapassagem_demanda_fora_ponta / atual.quantidade_ultrapassagem_demanda_fora_ponta;
                    acc.quantidadeUltrapassagemDemandaForaPontaCalculada +=
                        acc.quantidade_ultrapassagem_demanda_fora_ponta - diferenca >= 0 ? acc.quantidade_ultrapassagem_demanda_fora_ponta - diferenca : 0;
                    acc.valorUltrapassagemDemandaForaPontaCalculada +=
                        acc.quantidade_ultrapassagem_demanda_fora_ponta - diferenca >= 0
                            ? acc.quantidade_ultrapassagem_demanda_fora_ponta - valorPorKwUltrapassagem * diferenca
                            : 0;
                    // console.log({ comp: atual.competencia, valorPorKwDemanda, diferenca, qtd: atual.quantidade_demanda_fora_ponta });
                }

                return acc;
            },
            {
                quantidadeDemandaForaPontaCalculada: 0,
                valorDemandaForaPontaCalculada: 0,
                quantidadeUltrapassagemDemandaForaPontaCalculada: 0,
                valorUltrapassagemDemandaForaPontaCalculada: 0,
            }
        );

        const { quantidadeDemandaPontaCalculada, valorDemandaPontaCalculada, quantidadeUltrapassagemDemandaPontaCalculada, valorUltrapassagemDemandaPontaCalculada } = (
            props.dados.lista_quantidade_demanda_ponta || []
        ).reduce(
            (acc, atual) => {
                //se a quantidade atingiu 500, usa o proprio valor

                //se a quantidade atingiu 500, usa o proprio valor
                if (!modalidadeAtacado || atual.quantidade_demanda_ponta >= 500) {
                    acc.quantidadeDemandaPontaCalculada += atual.quantidade_demanda_ponta;
                    acc.valorDemandaPontaCalculada += atual.valor_demanda_ponta;
                    acc.quantidadeUltrapassagemDemandaPontaCalculada += atual.quantidade_ultrapassagem_demanda_ponta;
                    acc.valorUltrapassagemDemandaPontaCalculada += atual.valor_ultrapassagem_demanda_ponta;
                } else {
                    //senão for, incrementa até dar 500, e o valor incrementado desconta da ultrapassagem, caso exista.
                    const valorPorKwDemanda = atual.valor_demanda_ponta / atual.quantidade_demanda_ponta;
                    const diferenca = 500 - atual.quantidade_demanda_ponta;
                    acc.quantidadeDemandaPontaCalculada += atual.quantidade_demanda_ponta + diferenca;
                    acc.valorDemandaPontaCalculada += atual.valor_demanda_ponta + valorPorKwDemanda * diferenca; //usa o valor total incrementado com o valor proporcional aos kW adicionados

                    const valorPorKwUltrapassagem = atual.valor_ultrapassagem_demanda_ponta / atual.quantidade_ultrapassagem_demanda_ponta;
                    acc.quantidadeUltrapassagemDemandaPontaCalculada +=
                        acc.quantidade_ultrapassagem_demanda_ponta - diferenca >= 0 ? acc.quantidade_ultrapassagem_demanda_ponta - diferenca : 0;
                    acc.valorUltrapassagemDemandaPontaCalculada +=
                        acc.quantidade_ultrapassagem_demanda_ponta - diferenca >= 0 ? acc.quantidade_ultrapassagem_demanda_ponta - valorPorKwUltrapassagem * diferenca : 0;
                }

                return acc;
            },
            {
                quantidadeDemandaPontaCalculada: 0,
                valorDemandaPontaCalculada: 0,
                quantidadeUltrapassagemDemandaPontaCalculada: 0,
                valorUltrapassagemDemandaPontaCalculada: 0,
            }
        );

        props.atualizarAnalise({
            tipoAnalise: props.tipoAnalise,
            dados: {
                ...props.dados,
                quantidade_demanda_fora_ponta: quantidadeDemandaForaPontaCalculada,
                valor_demanda_fora_ponta: valorDemandaForaPontaCalculada,
                quantidade_demanda_ponta: quantidadeDemandaPontaCalculada,
                valor_demanda_ponta: valorDemandaPontaCalculada,
                quantidade_ultrapassagem_demanda_fora_ponta: quantidadeUltrapassagemDemandaForaPontaCalculada,
                valor_ultrapassagem_demanda_fora_ponta: valorUltrapassagemDemandaForaPontaCalculada,
                quantidade_ultrapassagem_demanda_ponta: quantidadeUltrapassagemDemandaPontaCalculada,
                valor_ultrapassagem_demanda_ponta: valorUltrapassagemDemandaPontaCalculada,
            },
        });
    }, [props.dados.id_modalidade_mercado_livre]);

    const backgroundColor = "#58c5fb";
    const color = "#08354c";
    const corValorEditado = "#008fd7";

    //o valor de custo gestao e encargos é mensal, então multiplica pela quantidade de meses no filtro do período
    const quantidadeMesesFiltrados = listarMesesAnosEntreCompetencias(props.filtro.competencia_inicial, props.filtro.competencia_final).length || 0;

    const custoGestaoNoPeriodoFiltrado = quantidadeMesesFiltrados * parseFloat(props.dados.valor_mensal_custo_gestao_mercado_livre) || 0;
    const custoTaxasEncargosNoPeriodoFiltrado = quantidadeMesesFiltrados * parseFloat(props.dados.valor_mensal_taxas_encargos_mercado_livre) || 0;

    const qtdTotalExcedenteForaPonta = (props.situacaoAtual.lista_energia_excedente || []).reduce((acc, item) => (acc += item.quantidade_energia_excedente_fora_ponta), 0);
    const valorTotalExcedenteForaPonta = (props.situacaoAtual.lista_energia_excedente || []).reduce((acc, item) => (acc += item.valor_energia_excedente_fora_ponta), 0);

    const qtdTotalExcedentePonta = (props.situacaoAtual.lista_energia_excedente || []).reduce((acc, item) => (acc += item.quantidade_energia_excedente_ponta), 0);
    const valorTotalExcedentePonta = (props.situacaoAtual.lista_energia_excedente || []).reduce((acc, item) => (acc += item.valor_energia_excedente_ponta), 0);

    const totalSituacaoAtual =
        (parseFloat(props.situacaoAtual.valor_energia_ponta) || 0) +
        (parseFloat(props.situacaoAtual.valor_energia_fora_ponta) || 0) +
        (parseFloat(props.situacaoAtual.valor_energia_reservado) || 0) +
        (parseFloat(props.situacaoAtual.valor_demanda_ponta) || 0) +
        (parseFloat(props.situacaoAtual.valor_demanda_fora_ponta) || 0) +
        (parseFloat(valorTotalExcedenteForaPonta) || 0) +
        (parseFloat(valorTotalExcedentePonta) || 0) +
        (props.exibirUltrapassagemDemanda ? parseFloat(props.situacaoAtual.valor_ultrapassagem_demanda_fora_ponta) || 0 : 0) +
        (parseFloat(props.situacaoAtual.valor_imposto) || 0) +
        (parseFloat(props.situacaoAtual.valor_bandeira) || 0);

    const subtotal =
        (parseFloat(props.dados.valor_energia_ponta_tusd) || 0) +
        (parseFloat(props.dados.valor_energia_ponta_te) || 0) + //calculado
        (parseFloat(props.dados.valor_energia_fora_ponta_tusd) || 0) +
        (parseFloat(props.dados.valor_energia_fora_ponta_te) || 0) + //calculado
        (parseFloat(props.dados.valor_energia_reservado_tusd) || 0) +
        (parseFloat(props.dados.valor_energia_reservado_te) || 0) + //calculado
        (parseFloat(props.dados.valor_demanda_ponta) || 0) +
        (parseFloat(props.dados.valor_demanda_fora_ponta) || 0) +
        (props.exibirUltrapassagemDemanda ? parseFloat(props.situacaoAtual.valor_ultrapassagem_demanda_fora_ponta) || 0 : 0) +
        (parseFloat(props.dados.valor_mensal_custo_gestao_mercado_livre) || 0) +
        (parseFloat(props.dados.valor_mensal_taxas_encargos_mercado_livre) || 0);

    // const totalImposto = (props.dados.aliquota_pis_pasep / 100) * subtotal + (props.dados.aliquota_cofins / 100) * subtotal + (props.dados.aliquota_icms / 100) * subtotal;
    const totalImposto = (props.dados.aliquota_calculada / 100) * subtotal;

    const totalComImposto = subtotal + totalImposto;

    //quando é economia garantida o valor alvo é o total descontado do percentual, caso contrario é o proprio total da situação atual
    const valorAlvo =
        props.dados.id_tipo_energia_mercado_livre == 3
            ? totalSituacaoAtual > 0
                ? totalSituacaoAtual - (props.dados.percentual_mercado_livre / 100) * totalSituacaoAtual
                : 0
            : totalSituacaoAtual;

    const percentualEconomizado = ((totalSituacaoAtual - totalComImposto) * 100) / totalSituacaoAtual;
    // console.log({
    //     totalSituacaoAtual,
    //     totalComImposto,
    //     percentualEconomizado,
    // });

    function calcularValoresMercadoLivre(dadosAtualizados) {
        if (dadosAtualizados.id_tipo_energia_mercado_livre == 3) {
            let decremento = 0;
            let totalComImposto = 0;
            let valor_energia_mercado_livre_por_mwh = 0;
            let valor_energia_ponta_te = 0;
            let valor_energia_fora_ponta_te = 0;
            let valor_energia_reservado_te = 0;
            const valorAlvoEconomiaGarantida = totalSituacaoAtual > 0 ? totalSituacaoAtual - (dadosAtualizados.percentual_mercado_livre / 100) * totalSituacaoAtual : 0;
            do {
                const diferencaAlvoSubtotal = valorAlvoEconomiaGarantida - subtotal - decremento;

                valor_energia_mercado_livre_por_mwh =
                    (diferencaAlvoSubtotal /
                        (dadosAtualizados.quantidade_energia_ponta + dadosAtualizados.quantidade_energia_fora_ponta + dadosAtualizados.quantidade_energia_reservado)) *
                    1000;

                valor_energia_ponta_te = (valor_energia_mercado_livre_por_mwh / 1000) * dadosAtualizados.quantidade_energia_ponta;
                valor_energia_fora_ponta_te = (valor_energia_mercado_livre_por_mwh / 1000) * dadosAtualizados.quantidade_energia_fora_ponta;
                valor_energia_reservado_te = (valor_energia_mercado_livre_por_mwh / 1000) * dadosAtualizados.quantidade_energia_reservado;

                const subtotalTeste =
                    (parseFloat(dadosAtualizados.valor_energia_ponta_tusd) || 0) +
                    (parseFloat(valor_energia_ponta_te) || 0) + //calculado
                    (parseFloat(dadosAtualizados.valor_energia_fora_ponta_tusd) || 0) +
                    (parseFloat(valor_energia_fora_ponta_te) || 0) + //calculado
                    (parseFloat(dadosAtualizados.valor_energia_reservado_tusd) || 0) +
                    (parseFloat(valor_energia_reservado_te) || 0) + //calculado
                    (parseFloat(dadosAtualizados.valor_demanda_ponta) || 0) +
                    (parseFloat(dadosAtualizados.valor_demanda_fora_ponta) || 0) +
                    (parseFloat(dadosAtualizados.valor_mensal_custo_gestao_mercado_livre) || 0) +
                    (parseFloat(dadosAtualizados.valor_mensal_taxas_encargos_mercado_livre) || 0);

                // const totalImposto = (props.dados.aliquota_pis_pasep / 100) * subtotal + (props.dados.aliquota_cofins / 100) * subtotal + (props.dados.aliquota_icms / 100) * subtotal;
                const totalImpostoTeste = (dadosAtualizados.aliquota_calculada / 100) * subtotalTeste;

                totalComImposto = subtotalTeste + totalImpostoTeste;
                const diferenca = totalComImposto - valorAlvoEconomiaGarantida;
                decremento += diferenca > 100 ? 1 : diferenca > 10 ? 0.1 : 0.01;
            } while (totalComImposto > valorAlvoEconomiaGarantida);

            dadosAtualizados.valor_energia_mercado_livre_por_mwh = valor_energia_mercado_livre_por_mwh;
            dadosAtualizados.valor_energia_ponta_te = valor_energia_ponta_te;
            dadosAtualizados.valor_energia_fora_ponta_te = valor_energia_fora_ponta_te;
            dadosAtualizados.valor_energia_reservado_te = valor_energia_reservado_te;
        }
        return dadosAtualizados;
    }

    return (
        <div style={{ backgroundColor: "#FFF", borderRadius: 8 }}>
            <Table id={props.id} minHeight="fit-content" responsive padding={6} borderRadius={25}>
                <THead>
                    <Tr>
                        <Th colSpan={4} alignCenter maxHeight="100%" backgroundColor={backgroundColor} color="#FFF" style={{ padding: 6 }}>
                            <div className="d-flex">
                                <div style={{ flexGrow: "1" }}>Mercado Livre</div>
                                <div>
                                    <BotaoExcluir event={() => props.removerAnalise({ tipoAnalise: "Mercado Livre" })} />
                                </div>
                            </div>
                        </Th>
                    </Tr>
                </THead>
                <TBody>
                    <Tr>
                        <Td colSpan={4} style={{ padding: 10 }}>
                            <Row id="selects">
                                <Select
                                    options={props.listaModalidadeMercadoLivre}
                                    label=""
                                    cols="12 12 4 4"
                                    placeholder="Selecione a modalidade"
                                    isClearable={false}
                                    value={props.dados.id_modalidade_mercado_livre}
                                    onChange={(data) =>
                                        props.atualizarAnalise({
                                            tipoAnalise: props.tipoAnalise,
                                            dados: {
                                                ...props.dados,
                                                id_modalidade_mercado_livre: data,
                                                id_tipo_energia_mercado_livre: null,
                                                percentual_mercado_livre: null,
                                            },
                                        })
                                    }
                                />
                                <Select
                                    options={props.listaTipoEnergiaMercadoLivre.filter(
                                        (tipo) =>
                                            //varejo aceita todos
                                            props.dados.id_modalidade_mercado_livre == 2 || [1, 2].includes(tipo.id) //1 e 2 é com incentivo e sem incentivo, pq atacado só aceita esses 2
                                    )}
                                    label=""
                                    readOnly={!props.dados.id_modalidade_mercado_livre}
                                    cols="12 12 5 5"
                                    placeholder="Selecione o tipo de energia"
                                    isClearable={true}
                                    value={props.dados.id_tipo_energia_mercado_livre}
                                    onChange={(data) => {
                                        props.atualizarAnalise({
                                            tipoAnalise: props.tipoAnalise,
                                            dados: {
                                                ...props.dados,
                                                id_tipo_energia_mercado_livre: data,
                                                percentual_mercado_livre: null,
                                            },
                                        });
                                    }}
                                />
                                {
                                    //com incentivo ou energia garantida precisa de percentual
                                    [1, 3].includes(parseInt(props.dados.id_tipo_energia_mercado_livre)) && (
                                        <Select
                                            options={
                                                props.dados.id_tipo_energia_mercado_livre == 1
                                                    ? [
                                                          { id: 50, valor: "50%" },
                                                          { id: 100, valor: "100%" },
                                                      ]
                                                    : props.dados.id_tipo_energia_mercado_livre == 3
                                                    ? Array.from({ length: 99 }, (_, i) => ({
                                                          id: i + 1,
                                                          valor: `${i + 1}%`,
                                                      }))
                                                    : []
                                            }
                                            label=""
                                            cols="12 12 3 3"
                                            placeholder="Percentual"
                                            isClearable={true}
                                            value={props.dados.percentual_mercado_livre}
                                            onChange={(data) => {
                                                const percentual_mercado_livre = parseFloat(String(data).replace(",", ".")) || 0;
                                                const dadosAtualizados = { ...props.dados, percentual_mercado_livre };
                                                const resultado = calcularValoresMercadoLivre(dadosAtualizados);

                                                props.atualizarAnalise({
                                                    tipoAnalise: props.tipoAnalise,
                                                    dados: { ...resultado },
                                                });
                                            }}
                                        />
                                    )
                                }
                            </Row>
                        </Td>
                    </Tr>
                    {props.dados.id_tipo_energia_mercado_livre != 3 && (
                        <Tr style={{ fontWeight: "450" }}>
                            <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                                Digite o Valor da Energia por MWh (R$)
                            </Td>
                            <Td width={200} colSpan={2} alignCenter>
                                <Row style={{ width: "98%", paddingInline: 5, justifyContent: "center" }}>
                                    <NumberFormat
                                        className="form-control"
                                        placeholder="0,00"
                                        decimalSeparator={","}
                                        decimalScale={2}
                                        fixedDecimalScale={2}
                                        allowNegative={false}
                                        onChange={(e) => {
                                            const dadosAtualizados = {
                                                ...props.dados,
                                                valor_energia_mercado_livre_por_mwh: parseFloat(e.target.value.replace(",", ".")) || 0,
                                                valor_energia_ponta_te: ((parseFloat(e.target.value.replace(",", ".")) || 0) / 1000) * props.dados.quantidade_energia_ponta,
                                                valor_energia_fora_ponta_te:
                                                    ((parseFloat(e.target.value.replace(",", ".")) || 0) / 1000) * props.dados.quantidade_energia_fora_ponta,
                                                valor_energia_reservado_te: ((parseFloat(e.target.value.replace(",", ".")) || 0) / 1000) * props.dados.quantidade_energia_reservado,
                                            };
                                            props.atualizarAnalise({
                                                tipoAnalise: props.tipoAnalise,
                                                dados: { ...dadosAtualizados },
                                            });
                                        }}
                                    />
                                </Row>
                            </Td>
                        </Tr>
                    )}
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                            Digite o Custo Mensal de Gestão (R$)
                        </Td>
                        <Td width={200} colSpan={2} alignCenter>
                            <Row style={{ width: "98%", paddingInline: 5, justifyContent: "center" }}>
                                <NumberFormat
                                    className="form-control"
                                    placeholder="0,00"
                                    decimalSeparator={","}
                                    decimalScale={2}
                                    fixedDecimalScale={2}
                                    allowNegative={false}
                                    onChange={(e) => {
                                        const dadosAtualizados = {
                                            ...props.dados,
                                            valor_mensal_custo_gestao_mercado_livre: parseFloat(e.target.value.replace(",", ".")) || 0,
                                        };
                                        props.atualizarAnalise({
                                            tipoAnalise: props.tipoAnalise,
                                            dados: { ...dadosAtualizados },
                                        });
                                    }}
                                />
                            </Row>
                        </Td>
                    </Tr>

                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                            Digite o Valor Mensal das Taxas e Encargos (R$)
                        </Td>
                        <Td width={200} colSpan={2} alignCenter>
                            <Row style={{ width: "98%", paddingInline: 5, justifyContent: "center" }}>
                                <NumberFormat
                                    className="form-control"
                                    placeholder="0,00"
                                    decimalSeparator={","}
                                    decimalScale={2}
                                    fixedDecimalScale={2}
                                    allowNegative={false}
                                    onChange={(e) => {
                                        const dadosAtualizados = {
                                            ...props.dados,
                                            valor_mensal_taxas_encargos_mercado_livre: parseFloat(e.target.value.replace(",", ".")) || 0,
                                        };
                                        props.atualizarAnalise({
                                            tipoAnalise: props.tipoAnalise,
                                            dados: { ...dadosAtualizados },
                                        });
                                    }}
                                />
                            </Row>
                        </Td>
                    </Tr>
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor={backgroundColor} color="#ecf5fd" paddingLeft={4} colSpan={2}>
                            Descrição
                        </Td>
                        <Td backgroundColor={backgroundColor} color="#ecf5fd" width={200} alignCenter>
                            Quantidade
                        </Td>
                        <Td backgroundColor={backgroundColor} color="#ecf5fd" width={200} alignCenter>
                            R$
                        </Td>
                    </Tr>

                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} rowSpan={2}>
                            Energia Ponta
                        </Td>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4}>
                            TUSD
                        </Td>
                        <Td width={200} alignCenter>
                            {props.dados.quantidade_energia_ponta ? adicionarPontosMilhar(props.dados.quantidade_energia_ponta, 6) + " kWh" : " - "}
                        </Td>
                        <Td width={200} alignCenter>
                            {props.dados.valor_energia_ponta_tusd
                                ? props.dados.id_tipo_energia_mercado_livre == 1 && props.dados.percentual_mercado_livre
                                    ? "R$ " +
                                      adicionarPontosMilhar(
                                          props.dados.valor_energia_ponta_tusd - (props.dados.percentual_mercado_livre / 100) * props.dados.valor_energia_ponta_tusd,
                                          6
                                      )
                                    : "R$ " + adicionarPontosMilhar(props.dados.valor_energia_ponta_tusd, 6)
                                : " - "}
                        </Td>
                    </Tr>
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4}>
                            TE
                        </Td>
                        <Td width={200} alignCenter>
                            {props.dados.quantidade_energia_ponta ? adicionarPontosMilhar(props.dados.quantidade_energia_ponta, 6) + " kWh" : " - "}
                        </Td>
                        <Td width={200} alignCenter color={props.dados.valor_energia_mercado_livre_por_mwh ? corValorEditado : null}>
                            <div>
                                {" "}
                                {props.dados.valor_energia_mercado_livre_por_mwh && props.dados.valor_energia_ponta_te
                                    ? "R$ " + adicionarPontosMilhar(props.dados.valor_energia_ponta_te, 6)
                                    : " - "}
                            </div>
                            <div>
                                {props.dados.id_tipo_energia_mercado_livre == 3 && props.dados.percentual_mercado_livre && props.dados.quantidade_energia_ponta
                                    ? `\n(${adicionarPontosMilhar(props.dados.valor_energia_ponta_te / props.dados.quantidade_energia_ponta, 6)} R$/kWh)`
                                    : null}
                            </div>
                        </Td>
                    </Tr>

                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} rowSpan={2}>
                            Energia Fora Ponta
                        </Td>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4}>
                            TUSD
                        </Td>
                        <Td width={200} alignCenter>
                            {props.dados.quantidade_energia_fora_ponta ? adicionarPontosMilhar(props.dados.quantidade_energia_fora_ponta, 6) + " kWh" : " - "}
                        </Td>
                        <Td width={200} alignCenter>
                            {props.dados.valor_energia_fora_ponta_tusd ? "R$ " + adicionarPontosMilhar(props.dados.valor_energia_fora_ponta_tusd, 6) : " - "}
                        </Td>
                    </Tr>
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4}>
                            TE
                        </Td>
                        <Td width={200} alignCenter>
                            {props.dados.quantidade_energia_fora_ponta ? adicionarPontosMilhar(props.dados.quantidade_energia_fora_ponta, 6) + " kWh" : " - "}
                        </Td>
                        <Td width={200} alignCenter color={props.dados.valor_energia_mercado_livre_por_mwh ? corValorEditado : null}>
                            <div>
                                {" "}
                                {props.dados.valor_energia_mercado_livre_por_mwh && props.dados.valor_energia_fora_ponta_te
                                    ? "R$ " + adicionarPontosMilhar(props.dados.valor_energia_fora_ponta_te, 6)
                                    : " - "}
                            </div>
                            <div>
                                {" "}
                                {props.dados.id_tipo_energia_mercado_livre == 3 && props.dados.percentual_mercado_livre && props.dados.quantidade_energia_fora_ponta
                                    ? `\n(${adicionarPontosMilhar(props.dados.valor_energia_fora_ponta_te / props.dados.quantidade_energia_fora_ponta, 6)} R$/kWh)`
                                    : null}
                            </div>
                        </Td>
                    </Tr>
                    {!!props.ucFiltrada.irrigante && (
                        <>
                            <Tr style={{ fontWeight: "450" }}>
                                <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} rowSpan={2}>
                                    Energia Reservado
                                </Td>
                                <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4}>
                                    TUSD
                                </Td>
                                <Td width={200} alignCenter>
                                    {props.dados.quantidade_energia_reservado ? adicionarPontosMilhar(props.dados.quantidade_energia_reservado, 6) + " kWh" : " - "}
                                </Td>
                                <Td width={200} alignCenter>
                                    {props.dados.valor_energia_reservado_tusd ? "R$ " + adicionarPontosMilhar(props.dados.valor_energia_reservado_tusd, 6) : " - "}
                                </Td>
                            </Tr>
                            <Tr style={{ fontWeight: "450" }}>
                                <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4}>
                                    TE
                                </Td>
                                <Td width={200} alignCenter>
                                    {props.dados.quantidade_energia_reservado ? adicionarPontosMilhar(props.dados.quantidade_energia_reservado, 6) + " kWh" : " - "}
                                </Td>
                                <Td width={200} alignCenter color={props.dados.valor_energia_mercado_livre_por_mwh ? corValorEditado : null}>
                                    <div>
                                        {props.dados.valor_energia_mercado_livre_por_mwh && props.dados.valor_energia_reservado_te
                                            ? "R$ " + adicionarPontosMilhar(props.dados.valor_energia_reservado_te, 6)
                                            : " - "}
                                    </div>
                                    <div>
                                        {props.dados.id_tipo_energia_mercado_livre == 3 && props.dados.percentual_mercado_livre && props.dados.quantidade_energia_reservado
                                            ? `(${adicionarPontosMilhar(props.dados.valor_energia_reservado_te / props.dados.quantidade_energia_reservado, 6)} R$/kWh)`
                                            : null}
                                    </div>
                                </Td>
                            </Tr>
                        </>
                    )}
                    {!!(props.ucFiltrada.geracao || props.ucFiltrada.id_unidade_geradora) && (
                        <>
                            <Tr style={{ fontWeight: "450" }}>
                                <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                                    Energia Excedente/Injetada Fora Ponta
                                </Td>
                                <Td width={200} alignCenter>
                                    {qtdTotalExcedenteForaPonta ? adicionarPontosMilhar(qtdTotalExcedenteForaPonta, 6) + " kWh" : " - "}
                                </Td>
                                <Td width={200} alignCenter>
                                    {"R$ " + adicionarPontosMilhar(0, 6)}
                                </Td>
                            </Tr>
                            <Tr style={{ fontWeight: "450" }}>
                                <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                                    Energia Excedente/Injetada Ponta
                                </Td>
                                <Td width={200} alignCenter>
                                    {qtdTotalExcedentePonta ? adicionarPontosMilhar(qtdTotalExcedentePonta, 6) + " kWh" : " - "}
                                </Td>
                                <Td width={200} alignCenter>
                                    {"R$ " + adicionarPontosMilhar(0, 6)}
                                </Td>
                            </Tr>
                        </>
                    )}
                    {props.ucFiltrada.id_modalidade_tarifaria == 2 && (
                        <>
                            <Tr style={{ fontWeight: "450" }}>
                                <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                                    Demanda Ponta
                                </Td>
                                <Td width={200} alignCenter>
                                    {props.dados.quantidade_demanda_ponta ? adicionarPontosMilhar(props.dados.quantidade_demanda_ponta, 6) + " kW" : " - "}
                                </Td>
                                <Td width={200} alignCenter>
                                    {props.dados.valor_demanda_ponta
                                        ? props.dados.id_tipo_energia_mercado_livre == 1 && props.dados.percentual_mercado_livre
                                            ? "R$ " +
                                              adicionarPontosMilhar(
                                                  props.dados.valor_demanda_ponta - (props.dados.percentual_mercado_livre / 100) * props.dados.valor_demanda_ponta,
                                                  6
                                              )
                                            : "R$ " + adicionarPontosMilhar(props.dados.valor_demanda_ponta, 6)
                                        : " - "}
                                </Td>
                            </Tr>
                            {props.exibirUltrapassagemDemanda && (
                                <Tr style={{ fontWeight: "450" }}>
                                    <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                                        Ultrapassagem de Demanda Ponta
                                    </Td>
                                    <Td width={200} alignCenter>
                                        {props.dados.quantidade_ultrapassagem_demanda_ponta
                                            ? adicionarPontosMilhar(props.dados.quantidade_ultrapassagem_demanda_ponta, 6) + " kW"
                                            : " - "}
                                    </Td>
                                    <Td width={200} alignCenter>
                                        {props.dados.valor_ultrapassagem_demanda_ponta
                                            ? props.dados.id_tipo_energia_mercado_livre == 1 && props.dados.percentual_mercado_livre
                                                ? "R$ " +
                                                  adicionarPontosMilhar(
                                                      props.dados.valor_ultrapassagem_demanda_ponta -
                                                          (props.dados.percentual_mercado_livre / 100) * props.dados.valor_ultrapassagem_demanda_ponta,
                                                      6
                                                  )
                                                : "R$ " + adicionarPontosMilhar(props.dados.valor_ultrapassagem_demanda_ponta, 6)
                                            : " - "}
                                    </Td>
                                </Tr>
                            )}
                        </>
                    )}
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                            Demanda Fora Ponta
                        </Td>
                        <Td width={200} alignCenter>
                            {props.dados.quantidade_demanda_fora_ponta ? adicionarPontosMilhar(props.dados.quantidade_demanda_fora_ponta, 6) + " kW" : " - "}
                        </Td>
                        <Td width={200} alignCenter>
                            {props.dados.valor_demanda_fora_ponta
                                ? props.dados.id_tipo_energia_mercado_livre == 1 && props.dados.percentual_mercado_livre
                                    ? "R$ " +
                                      adicionarPontosMilhar(
                                          props.dados.valor_demanda_fora_ponta - (props.dados.percentual_mercado_livre / 100) * props.dados.valor_demanda_fora_ponta,
                                          6
                                      )
                                    : "R$ " + adicionarPontosMilhar(props.dados.valor_demanda_fora_ponta, 6)
                                : " - "}
                        </Td>
                    </Tr>
                    {props.exibirUltrapassagemDemanda && (
                        <Tr style={{ fontWeight: "450" }}>
                            <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                                Ultrapassagem de Demanda Fora Ponta
                            </Td>
                            <Td width={200} alignCenter>
                                {props.dados.quantidade_ultrapassagem_demanda_fora_ponta
                                    ? adicionarPontosMilhar(props.dados.quantidade_ultrapassagem_demanda_fora_ponta, 6) + " kW"
                                    : " - "}
                            </Td>
                            <Td width={200} alignCenter>
                                {props.dados.valor_ultrapassagem_demanda_fora_ponta
                                    ? props.dados.id_tipo_energia_mercado_livre == 1 && props.dados.percentual_mercado_livre
                                        ? "R$ " +
                                          adicionarPontosMilhar(
                                              props.dados.valor_ultrapassagem_demanda_fora_ponta -
                                                  (props.dados.percentual_mercado_livre / 100) * props.dados.valor_ultrapassagem_demanda_fora_ponta,
                                              6
                                          )
                                        : "R$ " + adicionarPontosMilhar(props.dados.valor_ultrapassagem_demanda_fora_ponta, 6)
                                    : " - "}
                            </Td>
                        </Tr>
                    )}
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                            Custo de Gestão no Período Definido
                        </Td>
                        <Td width={200} alignCenter>
                            {" - "}
                        </Td>
                        <Td width={200} alignCenter>
                            {custoGestaoNoPeriodoFiltrado ? "R$ " + adicionarPontosMilhar(custoGestaoNoPeriodoFiltrado, 6) : " - "}
                        </Td>
                    </Tr>
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                            Custo de Taxas e Encargos no Período Definido
                        </Td>
                        <Td width={200} alignCenter>
                            {" - "}
                        </Td>
                        <Td width={200} alignCenter>
                            {custoTaxasEncargosNoPeriodoFiltrado ? "R$ " + adicionarPontosMilhar(custoTaxasEncargosNoPeriodoFiltrado, 6) : " - "}
                        </Td>
                    </Tr>
                    <Tr style={{ fontWeight: "450" }}>
                        <Td
                            backgroundColor="#ecf5fd"
                            color={color}
                            paddingLeft={4}
                            colSpan={2}
                            title={`Alíquota de Imposto Calculada: ${adicionarPontosMilhar(props.dados.aliquota_calculada)}% = R$ ${adicionarPontosMilhar(
                                (props.dados.aliquota_calculada / 100) * subtotal
                            )}`}
                            // title={`Alíquota ICMS: ${adicionarPontosMilhar(props.dados.aliquota_icms)}% = R$ ${adicionarPontosMilhar(
                            //     (props.dados.aliquota_icms / 100) * subtotal
                            // )}\nAlíquota PIS/Pasep: ${adicionarPontosMilhar(props.dados.aliquota_pis_pasep)}% = R$ ${adicionarPontosMilhar(
                            //     (props.dados.aliquota_pis_pasep / 100) * subtotal
                            // )}\nAlíquota Cofins: ${adicionarPontosMilhar(props.dados.aliquota_cofins)}% = R$ ${adicionarPontosMilhar((props.dados.aliquota_cofins / 100) * subtotal)}`}
                        >
                            Impostos (Base de Cálculo: R$ {adicionarPontosMilhar(subtotal)})
                        </Td>
                        <Td width={200} alignCenter>
                            N/A
                        </Td>
                        <Td width={200} alignCenter>
                            R$ {adicionarPontosMilhar(totalImposto)}
                        </Td>
                    </Tr>
                    <Tr style={{ fontWeight: "450", backgroundColor: percentualEconomizado > 0 ? "#09cf6c" : "#cb0f31" }}>
                        <Td color="#ecf5fd" paddingLeft={4} colSpan={2}>
                            Total
                        </Td>
                        <Td color="#ecf5fd" width={200} alignCenter>
                            =
                        </Td>
                        <Td color="#ecf5fd" width={250} alignCenter>
                            <div
                                title={
                                    props.dados.id_tipo_energia_mercado_livre == 3 && props.dados.percentual_mercado_livre
                                        ? `Total Esperado: (R$ ${adicionarPontosMilhar(totalSituacaoAtual)} - ${
                                              props.dados.percentual_mercado_livre
                                          }%) = R$ ${adicionarPontosMilhar(valorAlvo)}`
                                        : ""
                                }
                            >
                                {"R$ " + adicionarPontosMilhar(totalComImposto) + ` (${adicionarPontosMilhar(Math.abs(percentualEconomizado || 0))}%)`}
                            </div>
                        </Td>
                    </Tr>
                    <Tr>
                        <Td color="#ecf5fd" paddingLeft={4} colSpan={4}>
                            {percentualEconomizado && (props.dados.id_tipo_energia_mercado_livre == 2 || props.dados.percentual_mercado_livre) && (
                                <div style={{ filter: "brightness(1.1)" }}>
                                    <img
                                        src={percentualEconomizado > 0 ? avatarGradiosPositivo : avatarGradiosNegativo}
                                        alt={percentualEconomizado > 0 ? "Economizou" : "Não economizou"}
                                    />
                                </div>
                            )}
                        </Td>
                    </Tr>
                </TBody>
            </Table>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        filtro: state.diagnosticoEnergia.filtro,
        situacaoAtual: state.diagnosticoEnergia.situacaoAtual,
        listaTipoAnalise: state.diagnosticoEnergia.listaTipoAnalise,
        listaModalidadeMercadoLivre: state.diagnosticoEnergia.listaModalidadeMercadoLivre,
        listaTipoEnergiaMercadoLivre: state.diagnosticoEnergia.listaTipoEnergiaMercadoLivre,
    };
};

export default connect(mapStateToProps, null)(RenderizarAnaliseMercadoLivre);
